import React from 'react';
import { UserImage, UserImageProps } from './UserImage';
import UserImageTransformProvider from '../../contexts/UserImageTransformProvider';
import { useResponsiveScale } from '../../contexts/ResponsiveScaleContext';

/**
 * UserImageWithTransform - UserImage with TransformEventBus Integration
 *
 * Wrapper che combina:
 * - UserImage originale (funzionalità esistente)
 * - UserImageTransformProvider (gestione eventi TransformEventBus)
 * - ResponsiveScaleContext integration
 *
 * Questo componente abilita il sistema di eventi per le trasformazioni
 * mantenendo l'API identica al UserImage originale.
 *
 * Ogni istanza di questo componente ha il proprio provider scoped,
 * permettendo gestione indipendente delle trasformazioni per UserImage.
 */
export const UserImageWithTransform: React.FC<UserImageProps & {editable: boolean}> = (props) => {
  const { responsiveScaleSV } = useResponsiveScale();
  const { userImage, editable } = props;

  return (
    <UserImageTransformProvider
      editable={editable}
      responsiveScaleSV={responsiveScaleSV}
      userImage={userImage}
      enableEventDebug={__DEV__} // Enables debug in development for troubleshooting
    >
      <UserImage {...props} />
    </UserImageTransformProvider>
  );
};

export default UserImageWithTransform;